import React from 'react';
import styles from './Form.module.css';

export interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

const FormField: React.FC<FormFieldProps> = ({ 
  label, 
  required = false, 
  error,
  children,
  className = '' 
}) => {
  return (
    <div className={`${styles.formField} ${error ? styles.formFieldError : ''} ${className}`}>
      <label className={`${styles.label} ${error ? styles.formLabelError : ''}`}>
        {label} {required && '*'}
      </label>
      {children}
      {error && (
        <span className={styles.errorMessage}>{error}</span>
      )}
    </div>
  );
};

export default FormField;

